var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.22183 3.22183C-1.07394 7.51759 -1.07394 14.4824 3.22183 18.7782C7.51759 23.0739 14.4824 23.0739 18.7782 18.7782C23.0739 14.4824 23.0739 7.51759 18.7782 3.22183C14.4824 -1.07394 7.51759 -1.07394 3.22183 3.22183ZM4.63604 4.63604C1.12132 8.15076 1.12132 13.8492 4.63604 17.364C8.15076 20.8787 13.8492 20.8787 17.364 17.364C20.8787 13.8492 20.8787 8.15076 17.364 4.63604C13.8492 1.12132 8.15076 1.12132 4.63604 4.63604ZM9.5339 15.2427L10.9481 13.8285L9.1196 12H16.6568V10H9.1196L10.9481 8.17161L9.5339 6.7574L5.29122 11L9.5339 15.2427Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.e7227045582ee34767c7d9b5f0fa2001.svg";
export { ForwardRef as ReactComponent };